// extracted by mini-css-extract-plugin
module.exports = {"ProjectList":"ProjectList-module--ProjectList--l-I9v"};